import { QueryCache, QueryClient } from '@tanstack/react-query';
import HttpCodes from 'http-status-codes';
import { isAxiosError } from '@seeqdev/api';

const DEFAULT_QUERY_RETRY_COUNT = 3;

/**
 * React Query's default retry policy, except that a 401 is never retried: the session is gone, so retrying only keeps
 * the page behind a spinner. Pass it per query rather than as a client default, because a client-level `retry` would
 * also make imperative `fetchQuery` calls retry, which by default they don't.
 */
export function retryUnlessUnauthorized(failureCount: number, error: unknown): boolean {
  if (isAxiosError(error) && error.response?.status === HttpCodes.UNAUTHORIZED) {
    return false;
  }
  return failureCount < DEFAULT_QUERY_RETRY_COUNT;
}

export const apiQueryCache = new QueryCache();

/**
 * The app-wide react-query client. Shared between the main application tree and detached React
 * roots (e.g. CKEditor-rendered Organizer content) via <Root>, so all trees read the same cache.
 */
export const apiQueryClient = new QueryClient({ queryCache: apiQueryCache });
